export enum CalendarErrors {
  NOT_CONFIGURED = 'The requested action is currently not configured',
  NO_GUID = 'Fatal Error occurred, please try again later',
  DELETE_FAILED = 'Failed to delete rule, please try again later',
}
